import { IS_NNORMAL } from 'utils/constants/system';

const baseColumns = [
  {
    title: '',
    dataIndex: 'footLength',
    key: 'feet.length',
  },
];

if (IS_NNORMAL) {
  baseColumns.push({
    title: '',
    dataIndex: 'equivalent',
    key: 'feet.length.in',
    defaultValue: '*** Foot length (in)',
  });
}

const columns = {
  baseColumns,
};

export { columns };
